module.exports = __webpack_public_path__ + "img/heart-icon.cf73d219.svg";